import api from '../../utils/api';
import { HospitalResponse } from '../../models/MasterAdmin/hospital';
import { BookingSummary } from '../../models/MasterAdmin/bedBooking';

export const fetchHospitalProfile = async (vendorId: string): Promise<HospitalResponse> => {
  try {
    const response = await api.get(`/master-admin/hospital/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hospital profile:', error);
    throw error;
  }
};

export const fetchBookingSummary = async (vendorId: string): Promise<BookingSummary> => {
  try {
    const response = await api.get(`/master-admin/hospital/${vendorId}/bookings-summary`);
    return response.data;
  } catch (error) {
    console.error('Error fetching booking summary:', error);
    throw error;
  }
}; 